module.exports = __webpack_public_path__ + "93658d3a26d8219b9596648040c8beb4.svg";